import React, { useContext, Fragment,useEffect } from 'react';
import { ConfigurationContext } from '../Context/Configuration';
import MainBanner from '../Components/MainBanner/MainBanner';
import PictureTextFlexRow1 from '../Components/PictureTextFlexRow1/PictureTextFlexRow1'
import TextFlexRow1 from '../Components/TextFlexRow1/TextFlexRow1'
import VideoTextRow from '../Components/VideoTextRow/VideoTextRow'
import QuizBanner from '../Components/QuizBanner/QuizBanner'
import TextButtonBanner from '../Components/TextButtonBanner/TextButtonBanner'

const PreseedHerbicide = (props) => {

	const [config, update]=useContext(ConfigurationContext);

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

	return (
		<React.Fragment>

			<MainBanner 
				background_left="/preseedherbicide/images/DIGFARM_CANOLA_BWM_3804_2019@2x.png"
				background_left_alt=""
				background_right=""
				background_right_alt=""
			/>

			<div style={{ width: '100%', maxWidth: '1150px', margin: '0 auto' }}>

				<PictureTextFlexRow1
					title=				{config.whyPreseed.pictureTextFlexRow1[0].title}
					text=				{config.whyPreseed.pictureTextFlexRow1[0].text}
					image_src=			{config.whyPreseed.pictureTextFlexRow1[0].image_src}
					image_alt=			{config.whyPreseed.pictureTextFlexRow1[0].image_alt}
					image_caption=		{config.whyPreseed.pictureTextFlexRow1[0].image_caption}
				/>

				{config.whyPreseed.textFlexRow1.map((elem, index) => ((
					<TextFlexRow1
						key=			{index}
						title=			{elem.title}
						subtitle=		{elem.subtitle}
						text=			{elem.text}
					/>
				)))}
				
			</div>

			<TextButtonBanner
				title=					{config.whyPreseed.textButtonBanner[0].title}
				text=					{config.whyPreseed.textButtonBanner[0].text}
				button_text=			{config.whyPreseed.textButtonBanner[0].button_text}
				button_link=			{config.whyPreseed.textButtonBanner[0].button_link}
				cropImage=				{config.whyPreseed.textButtonBanner[0].cropImage}
				cropImageAlt=			{config.whyPreseed.textButtonBanner[0].cropImageAlt}
			/>

			<div style={{ width: '100%', maxWidth: '1150px', margin: '0 auto' }}>
				<VideoTextRow
					title=				{config.whyPreseed.banner[0].title}
					text=				{config.whyPreseed.banner[0].text}
					links=				{config.whyPreseed.banner[0].links}
					image_src=			{config.whyPreseed.banner[0].image_src}
					image_alt=			{config.whyPreseed.banner[0].image_alt}
				/>
			</div>
		</React.Fragment>
	);
}

export default PreseedHerbicide;

